module.exports = __webpack_public_path__ + "static/img/30.5bd2ccd2.gif";